import {sortBy, nthArg, mapValues, createSelector} from 'helpers';
import {subscription} from 'store/session';
import {createdDate} from 'store/common';

export const limits = createSelector(
  [ subscription ],
  ({ pro, premium }) => mapValues({
    activities: 25,
    diary: 25,
    goals: 3,
    notes: 25,
    recurring: 5,
  }, premium ? forPremium : ( pro ? forPro : nthArg(0) ))
);

function forPro(value, name) {
  if (/activities|notes/.test(name)) {
    return value*2;
  }
  return value;
}

function forPremium() {
  return Infinity;
}

export const createRestrictedSelector = (collection, name) => createSelector(
  [ collection, limits ],
  ( collection, limits ) => {
    const disabled = {};
    const sorted = sortBy(collection, createdDate);
    for (let i = 0; i < sorted.length; i++) {
      disabled[sorted[i].id] = i >= limits[name];
    }
    return ({ id }) => disabled[id];
  }
);
